import React, { Component } from "react";
import PropTypes from "prop-types";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";

import styles from "./Scrollable.css";

class Scrollable extends Component {
  static propTypes = {
    className: PropTypes.string,
    touchMomentum: PropTypes.bool
  };

  static defaultProps = {
    touchMomentum: true
  };

  ref = React.createRef();

  componentDidMount = () => {
    disableBodyScroll(this.ref.current);
  };

  componentWillUnmount = () => {
    enableBodyScroll(this.ref.current);
  };

  render = () => {
    const { touchMomentum, className, children } = this.props;

    let classNames = [styles.scrollable, className];

    if (touchMomentum) {
      classNames.push(styles.touchMomentum);
    }

    return (
      <div className={classNames.join(" ")} ref={this.ref}>
        {children}
      </div>
    );
  };
}

export default Scrollable;



// WEBPACK FOOTER //
// ./src/components/Scrollable/Scrollable.js